import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import EnhancedTable from '../../widgets/ResponsiveTable';
import ViewUtils from '../../ViewUtils';
import { EISADetailsHeaderForm } from './EISADetailsHeaderForm';
import AlertItem from "../../widgets/AlertItem";
import withMenuPermission from "../../widgets/withMenuPermission";

const headCells = [
    { id: 'TradeTestDate', numeric: false, disablePadding: true, label: 'EISA Date' },
    { id: "TradeTestResult", numeric: false, disablePadding: true, label: "Result" },
]


const utils = new ViewUtils();
const toolbarRef = React.createRef();
const learnerRef = React.createRef();

class ViewEISADetails extends Component {

    constructor(props) {
        super(props)
        this.state = {
            model: {
                LearnerQCTOLearnershipID: null
            },
            selectedTradeTest: null,
            keyUpSwitch: false,
            messsageAlert: null,
            messageStyle: null,
            showTable: true,
            searchParameters: [{ Name: "LearnerQCTOLearnershipID", Value: this.props.location.state.LearnershipID }]
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon', icon: 'CloseIcon' }
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'submit', label: '', tooltip: 'Submit EISA Details', icon: 'UpdateIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: 'cancel', label: '', tooltip: 'Cancel', icon: 'CancelIcon', disabled: true, visible: this.props.menuPermissionItem.Edit }
                    ]
                }
            ]
        };
    }

    handleToolbarButtonClick = (buttonId) => {
        if ("submit" === buttonId) {
            this.updateModules();
        }
        else if (buttonId === "close") {
            this.props.history.push({
                pathname: '/ViewQCTOLearnershipAssessment',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    LearnershipID: this.props.location.state.LearnershipID,
                    learnerNames: this.props.location.state.learnerNames,
                    permissionItem: this.props.location.state.permissionItem
                }
            })
        }
        else if (buttonId === "edit") {
            this.edit();
        }
        else if (buttonId === "cancel") {
            this.cancel();
        }
    }

    handleToolbarButtonClickClose = (buttonId) => {
        if ("close" === buttonId) {

        }
    }

    cancel = () => {
        this.setState({ model: null, selectedTradeTest: null, showTable: false }, () => {
            this.setState({ showTable: true })
        })
        toolbarRef.current.setButtonDisabled("submit", true);
        toolbarRef.current.setButtonDisabled("edit", true);
        toolbarRef.current.setButtonDisabled("cancel", true);
    }

    edit = () => {

        utils.invokeUrl("api/sims/LearnerEISADetails/GetEISADetails?ID=" + this.state.selectedTradeTest[0].Id, (response) => {
            this.setState({
                model: response,
                message: "",
                messageStyle: ""
            });

        }, this.error);
        toolbarRef.current.setButtonDisabled("edit", true);
        toolbarRef.current.setButtonDisabled("edit", false);
        toolbarRef.current.setButtonDisabled("cancel", false);
    }

    CheckAddTradeTest() {
        let url = "api/sims/LearnerEISADetails/CheckCanAddEISADetails?ID=" + this.props.location.state.LearnershipID;
        utils.invokeUrl(url, (response) => {
            if (response.Result === "0" && utils.isNull(this.state.selectedTradeTest)) {
                toolbarRef.current.setButtonDisabled("submit", true);
                toolbarRef.current.setButtonDisabled("namb", false);
            }

        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    CheckEditTradeTest = (tradetestId) => {
        let url = "api/sims/LearnerEISADetails/CheckCanEditEISADetails?ID=" + tradetestId;
        utils.invokeUrl(url, (response) => {
            if (response.Result !== "1") {
                toolbarRef.current.setButtonDisabled("edit", true);
                toolbarRef.current.setButtonDisabled("namb", false);
            }

        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    componentDidMount() {
        this.CheckAddTradeTest();
    }

    successCallback = (response) => {
        this.setState({
            showTable: false,
            message: response.Message, messageStyle: response.MessageType
        }, () => {
            this.setState({ showTable: true, message: response.Message, messageStyle: response.MessageType })
        });
        toolbarRef.current.setButtonDisabled("submit", true);
        toolbarRef.current.setButtonDisabled("edit", true);
        toolbarRef.current.setButtonDisabled("cancel", true);
    }

    updateModules() {
        const TradeTestID = this.state.selectedTradeTest;
        let data = {
            ID: TradeTestID,
            LearnerArtisanID: this.props.location.state.LearnershipID,
            ...this.state.model
        }
        let input = JSON.stringify(data);

        utils.invokeUrl("api/sims/LearnerEISADetails/SubmitEISADetails", (response) => {
            this.successCallback(response);
        }, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            body: input
        });
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedTradeTest: selection, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("edit", selection.length === 0);
                }
            )
            this.CheckEditTradeTest(selection[0].Id);
        }
        else {
            this.setState({ selectedTradeTest: null, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("edit", selection.length === 0);
                }
            )
        }
    }

    handleFormValueChange = (values) => {
        let newValues = null;
        if (!utils.isNull(values)) {
            newValues = { ...values };
        }
        if (!utils.isNull(newValues)) {
            if (JSON.stringify(this.state.model) !== JSON.stringify(newValues)) {
                if (!utils.isNull(newValues.TradeTestDate)) {
                    toolbarRef.current.setButtonDisabled("submit", false);
                    this.CheckAddTradeTest();
                }
                this.setState({
                    model: newValues,
                    Message: ""
                });
            }
        }
    }

    CheckHasData = (results) =>  {
        if (results.TotalNumberOfRows > 0) {
            toolbarRef.current.setButtonDisabled("submit", true)
        }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {`Learner > EISA Details > ${this.props.location.state.learnerNames}`}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                {this.state.showTable === true && (
                    <EISADetailsHeaderForm
                        ref={learnerRef}
                        viewRef={this}
                        id={this.props.location.state.LearnershipID}
                        valueChangeHandler={(values) => this.handleFormValueChange(values)}
                        controllerName={"LearnerEISADetails"}
                        data={this.state.model}
                        dataURL='api/sims/LearnerEISADetails/GetLearnerEISADetailsHeaderDetails' />
                )}
                <td>
                    <EnhancedToolbar
                        ref={toolbarRef}
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        config={this.toolbarConfig} />
                </td>

                <div>
                    {this.state.showTable === true && (
                        <EnhancedTable
                            headCells={headCells}
                            dataUrl="api/sims/LearnerEISADetails/GetLearnerEISADetails"
                            onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                            searchParameters={this.state.searchParameters} paged={true} onDataArrive={this.CheckHasData} />
                    )}
                </div>
            </ViewContainer>
        );
    }
}

export default withRouter(connect()(withMenuPermission(ViewEISADetails)));